<template>
  <div class="bg-light border-right no-print" id="sidebar-wrapper">
    <div class="sidebar" v-if="toReset">
      <div class="sidebar-menu list-group list-group-flush">
        <a @click="() => toReset('/', false, true)" style="width:100%"
          ><img
            src="/img/logo.svg"
            alt="Logo SIMRS"
            class="mb-3 mt-1"
            style="width: 100%;height: 2.125rem;object-fit: contain;object-position:left"
        /></a>
        <a
          @click="() => toReset('/pasien/form', false, true)"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['admin', 'admission', 'dokter', 'pasien'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          PASIEN BARU
        </a>
        <a
          @click="() => toReset('/ralan/daftar', false, true)"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['ralan'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          RAWAT JALAN
        </a>
        <a
          @click="() => toReset('/ranap/daftar', false, true)"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['ranap'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          RAWAT INAP
        </a>
        <a
          @click="() => toReset('/ugd/daftar', false, true)"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['ugd'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          RAWAT DARURAT
        </a>
        <a
          @click="() => toReset('/operasi/daftar', false, true)"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['operasi'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          OPERASI
        </a>
        <div v-for="(item, index) in sidebar" v-bind:key="item.title">
          <a
            @click="() => toReset(item.link, false, true)"
            :class="'menu-item ' + (item.title == active ? 'active' : '')"
            v-if="item.authorized.includes(role)"
          >
            <i
              :class="
                'menu-item-icon material-symbols-outlined text-' +
                  classes[index % 3]
              "
              :data-feather="item.icon"
              >{{ item.icon }}</i
            >
            <!-- <md-icon :class="'menu-item-icon material-symbols-outlined text-'+classes[index%3]">{{item.icon}}</md-icon> -->
            <span class="menu-item-text text-uppercase">{{
              item.label || item.title
            }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="sidebar" v-else>
      <div class="sidebar-menu list-group list-group-flush">
        <router-link to="/" style="width:100%"
          ><img
            src="/img/logo.svg"
            alt="Logo SIMRS"
            class="mb-3 mt-1"
            style="width: 100%;height: 2.125rem;object-fit: contain;object-position:left"
        /></router-link>
        <router-link
          to="/pasien/form"
          data-toggle="modal"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['admin', 'admission', 'dokter', 'pasien'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          PASIEN BARU
        </router-link>
        <router-link
          to="/ralan/daftar"
          data-toggle="modal"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['ralan'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          RAWAT JALAN
        </router-link>
        <router-link
          to="/ranap/daftar"
          data-toggle="modal"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['ranap'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          RAWAT INAP
        </router-link>
        <router-link
          to="/ugd/daftar"
          data-toggle="modal"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['ugd'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          RAWAT DARURAT
        </router-link>
        <router-link
          to="/operasi/daftar"
          data-toggle="modal"
          class="btn btn-secondary btn-block btn-with-icon-left mb-3"
          v-if="['operasi'].includes(role)"
          id="addActionBtn"
        >
          <i class="material-symbols-outlined">add</i>
          OPERASI
        </router-link>

        <div v-for="(item, index) in sidebar" v-bind:key="item.title">
          <router-link
            :to="item.link"
            :class="'menu-item ' + (item.title == active ? 'active' : '')"
            v-if="item.authorized.includes(role)"
          >
            <i
              :class="
                'menu-item-icon material-symbols-outlined text-' +
                  classes[index % 3]
              "
              :data-feather="item.icon"
              >{{ item.icon }}</i
            >
            <!-- <md-icon :class="'menu-item-icon material-symbols-outlined text-'+classes[index%3]">{{item.icon}}</md-icon> -->
            <span class="menu-item-text text-uppercase">{{
              item.label || item.title
            }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {role} from '@/config.js';
export default {
  name: "Sidebar",
  props: {
    msg: String,
    active: String,
    toReset: Function,
  },
  data: function() {
    return {
      role: "",
      sidebar: [
        {
          title: "Dashboard",
          link: "/dashboard/pasien",
          icon: "dashboard",
          authorized: [
            "admin",
            "admission",
            "ralan",
            "ranap",
            "ugd",
            "operasi",
            "dokter",
            "kasir",
            "apotik",
            "optik",
            "lab",
            "pasien",
          ],
        },
        {
          title: "Antrian",
          link: "/antrian",
          icon: "queue_play_next",
          authorized: ["admin", "admission"],
        },
        {
          title: "Rekam Medis",
          link: "/pasien",
          icon: "perm_contact_calendar",
          authorized: [
            "admin",
            "admission",
            "dokter",
            "ralan",
            "ranap",
            "ugd",
            "operasi",
            "kasir",
            "lab",
            "apotik",
            "optik",
          ],
        },
        {
          title: "Rawat Jalan",
          link: "/ralan",
          icon: "local_hospital",
          authorized: [
            "admin",
            "admission",
            "dokter",
            "ralan",
            "kasir",
            "ranap",
            "operasi",
            "lab",
            "apotik",
            "optik",
          ],
        },
        {
          title: "Rawat Inap",
          link: "/ranap",
          icon: "local_hotel",
          authorized: ["admin", "admission", "dokter", "ranap", "kasir"],
        },
        {
          title: "UGD",
          link: "/ugd",
          icon: "flash_on",
          authorized: [
            "admin",
            "admission",
            "dokter",
            "ugd",
            "kasir",
            "ranap",
            "operasi",
            "lab",
            "apotik",
            "optik",
          ],
        },
        {
          title: "Operasi",
          link: "/operasi",
          icon: "accessible",
          authorized: ["admin", "admission", "dokter", "operasi"],
        },
        {
          title: "Lab",
          link: "/lab",
          icon: "hourglass_full",
          authorized: ["admin", "lab"],
        },
        {
          title: "Apotik",
          link: "/apotik",
          icon: "lens",
          authorized: ["admin", "apotik"],
        },
        {
          title: "Optik",
          link: "/optik",
          icon: "visibility",
          authorized: ["admin", "optik"],
        },
        {
          title: "Kasir",
          link: "/kasir",
          icon: "account_balance_wallet",
          authorized: ["admin", "kasir"],
        },
        {
          title: "Komisi",
          link: "/komisi",
          icon: "request_quote",
          authorized: ["admin"],
        },
        {
          title: "Master Data",
          link: "/master/asuransi",
          icon: "data_usage",
          authorized: ["admin"],
        },
      ],
      classes: ["info", "primary", "secondary"],
      // classes:[
      //   'success','warning','info','danger','primary','secondary'
      // ]
    };
  },
  mounted: async function() {
    this.role = this.$store.state.role;
  },
};
</script>
